import ProviderUtils from "../../util/provider/providerUtils";

export default {
  namespaced: true,
  state: {
    provider: null,
  },

  getters: {
    provider: (state) => state.provider,
    isVivoProvider: (state) => state.provider === "vivo",
    isWhitelabel: (state) => ["vivo", "unifique", "abc", "vero", 'master'].includes(state.provider),
    providerColor: (state, _getters, _rootState, rootGetters) => {
        const whitelabelStyle = rootGetters["accountWhitelabel/style"];

        if (whitelabelStyle) return whitelabelStyle.primary;

        return {
        wcs: "#00494E",
        haggi: "#00494E",
        tely: "#00494E",
        ntcorp: "#00494E",
        "data-carrier": "#00494E",
        vivo: "#660099",
        vero: "#f3953f",
        unifique: "#00A2FF",
        abc: "#5F1319",
        wifeed: "#00494E",
        master: '#0031CF',
        }[state.provider] || "#00494E";
    },
  },

  mutations: {
    LAYOUT_SET_PROVIDER(state, payload) {
      state.provider = payload;
    },
  },

  actions: {
    setProvider({ commit }) {
      const provider =
        ProviderUtils.extractFromUrl(location.href) ||
        ProviderUtils.getFromCookie() ||
        ProviderUtils.getFromLocalStorage();

      if (!provider || !ProviderUtils.isValid(provider)) return;

      ProviderUtils.setInLocalStorage(provider);
      commit("LAYOUT_SET_PROVIDER", provider);
    },
  },
};
